import { useState, useEffect } from "react";

const footerLinks = [
  { href: "#features", label: "核心功能" },
  { href: "#hot", label: "热门瓜事" },
  { href: "#version", label: "版本更新" },
  { href: "#download", label: "下载安装" },
  { href: "#faq", label: "常见问题" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#top" className="flex items-center gap-2.5 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-water-flash-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">吃瓜神器</span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
              吃瓜神器是一款专注于娱乐热点聚合与阅读的安卓应用，帮你高效浏览明星动态、热播内容与综艺话题。理性吃瓜，从这里开始。
            </p>
            <div className="mt-5 flex gap-2">
              {["ri-android-fill", "ri-fire-fill", "ri-community-fill", "ri-chat-3-fill"].map((ic) => (
                <span
                  key={ic}
                  className="flex h-9 w-9 items-center justify-center rounded-lg border border-background-200 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  <i className={`${ic} text-lg`}></i>
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">快速导航</h4>
            <ul className="mt-4 flex flex-col gap-3">
              {footerLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-700 transition-colors hover:text-primary-600">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-foreground-950">联系与支持</h4>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-foreground-700">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-foreground-600"></i>
                <span>support@chigua-example.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-foreground-600"></i>
                <span>服务时间：每天 9:00 - 22:00</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-foreground-600"></i>
                <span>请通过官方渠道下载，注意识别假冒版本与付费骗局。</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-600">© 2026 吃瓜神器 版权所有</p>
          <p className="text-xs text-foreground-600">理性吃瓜 · 不信谣 · 不传谣</p>
        </div>
      </div>
      <BackToTop />
    </footer>
  );
}

function BackToTop() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="#top"
      aria-label="返回顶部"
      className={`fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 shadow-lg transition-all hover:bg-primary-600 ${
        show ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-3 opacity-0"
      }`}
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </a>
  );
}